export default {
  mounted() {
    document.title = 'McDonald\'s Brunei'; // Set the title to the component's name or a default value
  }
};